import { z } from 'zod';

import { CanonicalPaymentMethodSchema } from './finance.schemas.js';

export const PaymentMethodChargeItemSchema = z.object({
  method: CanonicalPaymentMethodSchema,
  feePercentBps: z.number().int().nonnegative().nullable(),
  feeFixedCents: z.string().regex(/^\d+$/).nullable(),
  settlementAccountId: z.uuid().nullable(),
  feeAccountId: z.uuid().nullable(),
});
export type PaymentMethodChargeItem = z.infer<typeof PaymentMethodChargeItemSchema>;

export const PlacePaymentMethodChargeViewItemSchema = PaymentMethodChargeItemSchema.extend({
  settlementAccountKey: z.string(),
  feeAccountKey: z.string().nullable(),
});
export type PlacePaymentMethodChargeViewItem = z.infer<
  typeof PlacePaymentMethodChargeViewItemSchema
>;

export const GetPlacePaymentMethodChargesResponseSchema = z.object({
  items: z.array(PlacePaymentMethodChargeViewItemSchema),
});
export type GetPlacePaymentMethodChargesResponse = z.infer<
  typeof GetPlacePaymentMethodChargesResponseSchema
>;

export const UpsertPlacePaymentMethodChargesBodySchema = z.object({
  items: z.array(PaymentMethodChargeItemSchema),
});
export type UpsertPlacePaymentMethodChargesBody = z.infer<
  typeof UpsertPlacePaymentMethodChargesBodySchema
>;

export const CreateReceivableAdvanceBodySchema = z.object({
  feePercentBps: z.number().int().nonnegative(),
});
export type CreateReceivableAdvanceBody = z.infer<typeof CreateReceivableAdvanceBodySchema>;

export const CreateReceivableAdvanceResponseSchema = z.object({
  id: z.uuid(),
  receivableId: z.uuid(),
  principalCents: z.string().regex(/^\d+$/),
  feePercentBps: z.number().int().nonnegative(),
  feeCents: z.string().regex(/^\d+$/),
});
export type CreateReceivableAdvanceResponse = z.infer<typeof CreateReceivableAdvanceResponseSchema>;
